export const PAYMENT_METHOD_WEBHOOK_RETRY = {
  maxAttempts: 10,
  delayMs: 5_000,
} as const;
